import instance from 'api';
import { AxiosError, AxiosResponse } from 'axios';
import { ApiResponse, BaseApi } from 'baseApi';
import { endpoints } from 'endpoints.config';
import { FreeTrialSubscriptionParser } from 'pages/subscribeFreeTrial/models';

const UNKNOWN_ERROR_MESSAGE = 'Sorry, something went wrong. Please try again.';

export class FreeTrialSubscriptionApi extends BaseApi {
  // get free trial subscription packages
  public static getPackages = async (): Promise<any> => {
    try {
      const result: AxiosResponse<ApiResponse<any>> = await instance.get(
        endpoints.public.subscription.getSubscriptionsFreeTrial
      );

      if (FreeTrialSubscriptionApi.isResponseSuccessful(result.data)) {
        const data = result.data.details;
        return FreeTrialSubscriptionApi.successResponse(data);
      } else {
        const errors = result.data.errors;
        if (errors) {
          const message = FreeTrialSubscriptionParser.parseError(errors);
          return FreeTrialSubscriptionApi.errorResponse(message);
        } else {
          throw new Error(); // Caught below to trigger unknown error
        }
      }
    } catch (error: AxiosError | any) {
      if (error.response) {
        const errors = error.response.data.errors;
        if (errors) {
          const message = FreeTrialSubscriptionParser.parseError(errors);
          return FreeTrialSubscriptionApi.errorResponse(message);
        }
      }
      return FreeTrialSubscriptionApi.errorResponse(UNKNOWN_ERROR_MESSAGE);
    }
  };

  public static submitFreeTrialPackages = async (
    registrationToken: string,
    generalPackagesId: number,
    subjectsIds: any
  ): Promise<any> => {
    try {
      const payload =
        FreeTrialSubscriptionParser.buildSubmitFreeTrialPackagesPayload(
          registrationToken,
          generalPackagesId,
          subjectsIds
        );

      const result: AxiosResponse<ApiResponse<any>> = await instance.post(
        endpoints.public.subscription.subscribeFreeTrial,
        payload
      );

      if (FreeTrialSubscriptionApi.isResponseSuccessful(result.data)) {
        const data = result.data.details;
        return FreeTrialSubscriptionApi.successResponse(data);
      } else {
        const errors = result.data.errors;
        if (errors) {
          const message = FreeTrialSubscriptionParser.parseError(errors);
          return FreeTrialSubscriptionApi.errorResponse(message);
        } else {
          throw new Error(); // Caught below to trigger unknown error
        }
      }
    } catch (error: AxiosError | any) {
      if (error.response) {
        const errors = error.response.data.errors;
        if (errors) {
          const message = FreeTrialSubscriptionParser.parseError(errors);
          return FreeTrialSubscriptionApi.errorResponse(message);
        }
      }
      return FreeTrialSubscriptionApi.errorResponse(UNKNOWN_ERROR_MESSAGE);
    }
  };
}
